import React from 'react'
import PropTypes from 'prop-types'
import { SHIPMENT_STATUS } from 'domains/customer-order/constants'
import { Badge, UncontrolledTooltip  } from 'reactstrap'
import StringUtil from 'utils/string-util'

const propTypes = {
  status: PropTypes.string
}

const colorMap = {
  [SHIPMENT_STATUS.PENDING]   : 'warning',
  [SHIPMENT_STATUS.SHIPPED]   : 'info',
  [SHIPMENT_STATUS.DELIVERED] : 'success',
  [SHIPMENT_STATUS.COMPLETED] : 'success',
  [SHIPMENT_STATUS.CANCELLED] : 'danger',
  [SHIPMENT_STATUS.FAILED]    : 'danger',
  [SHIPMENT_STATUS.RETURNED]  : 'danger'
}

const tooltipMap = {
  [SHIPMENT_STATUS.PENDING]   : 'Menunggu untuk diproses.',
  [SHIPMENT_STATUS.SHIPPED]   : 'Paket dalam proses pengiriman.',
  [SHIPMENT_STATUS.DELIVERED] : 'Paket telah sampai tujuan.',
  [SHIPMENT_STATUS.COMPLETED] : 'Paket telah sampai tujuan.',
  [SHIPMENT_STATUS.CANCELLED] : 'Pengiriman paket dibatalkan oleh pihak Ops.',
  [SHIPMENT_STATUS.FAILED]    : 'Pengiriman paket dibatalkan oleh jasa pengiriman.',
  [SHIPMENT_STATUS.RETURNED]  : 'Paket dikembalikan oleh kurir jasa pengiriman'
}

/**
 * @param {string} status
 */
const CustomerOrderShipmentStatusBadge = ({ status }) => {
  const color       = colorMap[status] || 'default'
  const tooltipText = tooltipMap[status] || 'Menunggu untuk diproses.'
  const tooltipId   = `status-badge-${Math.floor(Math.random() * Date.now()).toString(36)}`

  return (
    <Badge
      className='badge-lg'
      color={ color }
      id={ tooltipId }
      pill
    >
      { StringUtil.humanizeUpperCase(status) }
      <i className="ml-1 fas fa-info-circle 2x" />
      <UncontrolledTooltip placement="top" target={ tooltipId }>
        { tooltipText }
      </UncontrolledTooltip>
    </Badge>
  )
}

CustomerOrderShipmentStatusBadge.propTypes = propTypes

export default CustomerOrderShipmentStatusBadge